module.exports = __webpack_public_path__ + "fonts/font.3195a763.woff";